/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1ProgrammeRequest } from './V1ProgrammeRequest'
import {
    V1ProgrammeRequestFromJSON,
    V1ProgrammeRequestFromJSONTyped,
    V1ProgrammeRequestToJSON,
    V1ProgrammeRequestToJSONTyped
} from './V1ProgrammeRequest'

/**
 *
 * @export
 * @interface V1ProgrammeRequestList
 */
export interface V1ProgrammeRequestList {
    /**
     *
     */
    items?: Array<V1ProgrammeRequest>
}

/**
 * Check if a given object implements the V1ProgrammeRequestList interface.
 */
export function instanceOfV1ProgrammeRequestList(
    value: object
): value is V1ProgrammeRequestList {
    return true
}

export function V1ProgrammeRequestListFromJSON(
    json: any
): V1ProgrammeRequestList {
    return V1ProgrammeRequestListFromJSONTyped(json, false)
}

export function V1ProgrammeRequestListFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ProgrammeRequestList {
    if (json == null) {
        return json
    }
    return {
        items:
            json['items'] == null
                ? undefined
                : (json['items'] as Array<any>).map(V1ProgrammeRequestFromJSON)
    }
}

export function V1ProgrammeRequestListToJSON(
    json: any
): V1ProgrammeRequestList {
    return V1ProgrammeRequestListToJSONTyped(json, false)
}

export function V1ProgrammeRequestListToJSONTyped(
    value?: V1ProgrammeRequestList | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        items:
            value['items'] == null
                ? undefined
                : (value['items'] as Array<any>).map(V1ProgrammeRequestToJSON)
    }
}
